import http from "../services/http-common";

const getAll = (url) => {
  return http.get(`${url}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const get = (url, id) => {
  return http.get(`${url}` + "?id=" + `${id}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const create = (url, data) => {
  return http.post(`${url}`, data, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const update = (url, id, data) => {
  return http.put(`${url}` + "/" + `${id}`, data, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const remove = (url, id) => {
  return http.delete(`${url}` + "?id=" + `${id}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const removeAll = (url) => {
  return http.delete(`${url}` + "/", { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const getdoc = (url, id) => {
  return http.get(`${url}` + "?id=" + `${id}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("jwtToken")}` } }).catch(error => {
    console.log("Token has been expired : " + error);
  });
}
const autherize = (url, data) => {
  return http.post(`${url}`, data).catch(error => {
    console.log("Token has been expired : " + error);
  });
};

const CommonService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  getdoc,
  autherize
};

export default CommonService;
